import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ConfirmModalComponent } from '../views/generic/modals/confirm-modal/confirm-modal.component';
import { EditUserModalComponent } from '../views/admin-users/modals/edit-user-modal/edit-user-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ModalsService {

    bsModalRef: BsModalRef | undefined;

    constructor(private modalService: BsModalService) {}

    showConfirmModal(callbackConfirm?: () => void, callbackCancel?: () => void) {
        const modalParams = {
            callbackConfirm: callbackConfirm,
            callbackCancel: callbackCancel
        };

        this.bsModalRef = this.modalService.show(ConfirmModalComponent, {initialState: modalParams});
    }
}
